module.exports = __webpack_public_path__ + "img/34.1e89c41e.jpg";